import * as React from "react"
import { Link } from "gatsby"

import * as button from "./button.module.css"

const Button = ({ title, icon, link, type, onClick }) => {
  if (type === `secondary`) {
    return (
      <Link to={link}>
        <button className={button.secondary}>
          {title} {icon && <div className={button.icon}>{icon}</div>}
        </button>
      </Link>
    )
  } else {
    return (
      <Link to={link}>
        <button className={button.primary}>
          {title} {icon && <div className={button.icon}>{icon}</div>}
        </button>
      </Link>
    )
  }
}

export default Button
